// Strings for S3-manual. Only the S3-manual worker edits this file (see web/README.md).
// Copy from prototype/index.html and assets/app.js; DRAFT = no source there (w2-03 report).
export default {
  title: 'What was the flight number?',
  airline: 'Airline',
  airlinePlaceholder: 'Vueling',
  number: 'Number',
  numberPlaceholder: '6650',
  backToList: 'Back to the flight list',
  notFound:
    "We couldn't find {ident} on {date}. Check the number, or continue anyway and we'll verify it later.",
  continueAnyway: 'Continue anyway',
  // Q11: defunct airlines are listed last, greyed, not selectable (DECISION-NEEDED). DRAFT copy.
  'defunct.stopped': 'Stopped flying in {month}', // DRAFT
  'defunct.stoppedUnknown': 'No longer flying', // DRAFT
  'defunct.insolvent': "It's insolvent, so claims against it can't be pursued.", // DRAFT
} as const;
